import React from "react";
import "./index.less";
import { useNavigate } from "react-router-dom";
import logo from "@/assets/Logo.png";
import { NAV_LINKS } from "@/constants/navigation";

const BottomPage = () => {
  const navigate = useNavigate();

  return (
    <div className="contact_warp">
      <div className="contact_box row">
        <div className="left col-12 col-lg-5">
          <div className="logo">
            <img src={logo} alt="Highdim Smart" />
          </div>
          <p className="slogan">
            Unlock Unlimited Potential with Cutting-Edge Compute Power.
          </p>
        </div>
        <div className="right col-12 col-lg-6">
          <div className="contact_item">
            {NAV_LINKS.map((item) => (
              <div
                className="title"
                key={item.key}
                onClick={() => navigate(item.path)}
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomPage;
